import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import AppIcon from "@/components/Core/AppIcon";
import Translations from "@/components/Core/Translations";
import { colors } from "@/theme";

interface NotificationMenuHeaderProps {
  disabled: boolean;
  onMarkAllRead: () => void;
}

export const NotificationMenuHeader = ({
  disabled,
  onMarkAllRead,
}: NotificationMenuHeaderProps) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    px={2}
    py={1.5}
    sx={{ borderBottom: `1px solid ${colors.grey[200]}` }}
  >
    <Typography variant="subtitle1" component="h3" fontWeight={600}>
      <Translations text="notification.title" />
    </Typography>
    <Button
      startIcon={<AppIcon name="check" size={16} />}
      variant="outlined"
      size="small"
      sx={{
        color: colors.grey[600],
        borderColor: colors.grey[300],
        "&:hover": {
          borderColor: colors.grey[400],
        },
      }}
      onClick={onMarkAllRead}
      disabled={disabled}
    >
      <Translations text="notification.mark" />
    </Button>
  </Stack>
);
